import { WelcomeTemplateEntity } from '../../../../../types';
import SharedDialog from '../../../../shared/shared-dialog';
import StepWelcomeTemplateReview from './form-step/step-welcome-template-review-old';
import Stack from '@mui/material/Stack';

interface WelcomeTemplateDetailsDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedWelcomeTemplate: WelcomeTemplateEntity;
}

export default function WelcomeTemplateDetailsDialog({
  open,
  handleClose,
  selectedWelcomeTemplate,
}: WelcomeTemplateDetailsDialogProps) {
  return (
    <SharedDialog
      open={open}
      handleClose={handleClose}
      title="Welcome Template Details"
      maxWidth="lg"
      dialogContent={
        <Stack>
          <StepWelcomeTemplateReview
            selectedTemplate={selectedWelcomeTemplate}
          />
        </Stack>
      }
      primaryButton={{
        loading: false,
        action: handleClose,
        disabled: false,
        title: 'Close',
      }}
    />
  );
}
